import { Component, Input } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { Order } from 'src/app/core/orders.service';

@Component({
  selector: 'app-order-details-general-company',
  templateUrl: './order-details-general-company.component.html',
  styleUrls: ['./order-details-general-company.component.scss'],
})
export class OrderDetailsGeneralCompanyComponent {
  @Input() order?: Order;
  constructor(private navigation_service: NavigationService) {}

  getSellerFullName(): string {
    if (this.order) {
      const full_name = `${this.order.seller_firstname} ${this.order.seller_lastname}`;
      if (full_name.length > 30) {
        return full_name.slice(0, 27) + '...';
      } else {
        return full_name;
      }
    } else {
      return '-';
    }
  }

  getFormattedPhone(): string {
    if (!this.order?.seller_phone) {
      return '-';
    }

    return this.order?.seller_phone.prefix + ' ' + this.order?.seller_phone.value;
  }

  onDetailsClick(company_id: string): void {
    this.navigation_service.toCompanyDetails(company_id);
  }
}
